import type { LoggbokSvar } from '../api'

/** Svarene på ett kort, som en rad å trykke på.
 *
 *  Egen fil fordi den stilles to steder: i køen, og på kartet over besøket. Å
 *  sende noen bort fra kortet for å se og så tilbake for å svare er to reiser
 *  for én avgjørelse, og den andre er den man glemmer -- så raden følger med
 *  dit beviset er. Samme ord, samme rekkefølge og samme høyde begge steder: to
 *  kopier av den ville drevet fra hverandre på nøyaktig den måten som gjør at
 *  folk svarer forskjellig avhengig av hvilken skjerm de sto på. */
export function Svarrad({ svar, valgt, laast, onSvar }: {
  svar: LoggbokSvar[]
  valgt?: string | null
  laast?: boolean
  onSvar: (key: string) => void
}) {
  return (
    <div className="loggbok-svar">
      {svar.map((s) => (
        <button key={s.key} type="button" disabled={laast}
          className={`fchip${valgt === s.key ? ' paa' : ''}`}
          aria-pressed={valgt === s.key}
          onClick={() => onSvar(s.key)}>{s.label}</button>
      ))}
    </div>
  )
}
